export default "__VITE_ASSET__5w_ju1yE__"